import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { BillingAttempt } from 'src/features/billingAttempts/utils/types';

const RESOURCE = '/charges/billing-attempt/:attemptId/retry/';

type MutationFnType = typeof mutationFn;

interface DTO {
    attemptId: string;
}

/**
 * Re-runs that unit of work and returns the resulting attempt.
 *
 * Retrying an attempt whose item is no longer due returns the ORIGINAL attempt unchanged, so the
 * caller must compare ids: an unchanged id means "nothing to do", not success.
 */
const mutationFn = ({ attemptId }: DTO): Promise<BillingAttempt> => {
    return axios.post(formatResourcePath(RESOURCE, { attemptId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useRetryBillingAttempt };
